import React from "react";
import { ContentSection } from "../Layout/ContentSection";
import { HeadingSection } from "../Layout/HeadingSection";
import { CacaoPointComponent } from "../Toolbar/CacaoPoint";
import { RLink } from "../DesignSystem/RLink";
import { Paragraph } from "../DesignSystem/formatting/Paragraph";

export const ExplainCacaophonyPage = (): JSX.Element => {
  return (
    <div>
      <HeadingSection title="Cacaophony Minutae"></HeadingSection>

      <ContentSection>
        <div>
          <h3> ROUNDS </h3>
        </div>
        <Paragraph>
          Your goal in the CACAOPHONY is to write amazing original music, qualify into the final round, and win!
        </Paragraph>
        <Paragraph>
          The way that you qualify is to score over 100 <CacaoPointComponent /> in the qualification rounds.
        </Paragraph>
        <Paragraph>
          In the qualifications rounds, you’ll write a song. Once the deadline is up, everyone will listen and vote on
          everyone’s songs. I will announce the results after the deadline is over, and the top 15 or so scorers will
          receive points based on how well they did.
        </Paragraph>
        .<h3>ROUND ORDER:</h3>
        <ul>
          <li>Main Round 1 (3/3 - 3/11)</li>
          <li>Bonus Round! (3/12 - 3/16)</li>
          <li>Main Round 2 (3/17 - 3/25)</li>
          <li>Bonus Round! 2 (3/26 - 3/30)</li>
          <li>Qualification round 3 (3/31 - 4/8)</li>
          <li>Bonus Round! 3 (4/9 - 4/13)</li>

          <li>
            <strong>Final (Bonus) Round (4/16-4/19)</strong>
          </li>
          <li>
            <strong>FINAL ROUND (4/12-5/5) (two weeks!)</strong>
          </li>
        </ul>
        <h3>ROUND TYPES</h3>
        <Paragraph>There are two types of rounds:</Paragraph>
        <ol>
          <li>
            <strong>NORMAL</strong> rounds. Weekend to weekend rounds where you write any unique piece of music. These
            give the majority of your points and will be the meat and potatoes of the Cacaophony.
          </li>

          <li>
            <strong>BONUS</strong> rounds. These will be short, they will have weird rules (like write a song the same
            forwards and backwards), and they will probably be really stupid.
          </li>
        </ol>
        <Paragraph>You do not need to participate in every round! If you’re busy, or need a break, you can skip out without penalty.</Paragraph>
        <h3>FAQ</h3>
        <div>Are collabs allowed? YES, up to two people!</div>
        <div>Can I submit 500 songs? No.</div>
        <div>Can I submit more than 1 song? Still no.</div>
        <div>
          Can I use an old project, or borrow a melody, or... All songs must be original and made from scratch! Evidence
          of the contrary will be a ban, or maybe a DQ if the judges feel generous!
        </div>
        <h2>
          <RLink className="darklink-notzelda" to="/cacaophony">
            Go Back.
          </RLink>
        </h2>
      </ContentSection>
    </div>
  );
};